import { useState } from "react";
import Alert from "@amzn/meridian/esm/components/alert";
import Column from "@amzn/meridian/esm/components/column";
import Row from "@amzn/meridian/esm/components/row";
import Text from "@amzn/meridian/esm/components/text";
import { orgColor, WHOS_WHO_STATE } from "../whosWho.constants";
import { THEME_COLOR } from "../../../styles/colors";
import InviteeCard from "./InviteeCard";
import WhosWhoOrgPills from "../WhosWhoOrgPills";
import SkeletonCard from "../SkeletonCard";

// Legacy rollback surface retained until Who's Who V2 rollout is complete.
const accentFor = (person, orgColorMap) => orgColorMap[person.org] || THEME_COLOR.MIST_GRAY;

const LegacyWhosWhoPanel = ({ state, invitees }) => {
  const [orgFilter, setOrgFilter] = useState(null);
  const hasInvitees = Boolean(invitees && invitees.length > 0);

  // Preserve V1's code-unit sort and resulting color assignment exactly.
  const orgsList = hasInvitees
    ? Array.from(new Set(invitees.filter((p) => !p.external && p.org).map((p) => p.org))).sort()
    : [];

  const orgColorMap = {};
  orgsList.forEach((org, i) => {
    orgColorMap[org] = orgColor(i);
  });

  const visibleInvitees = !hasInvitees
    ? []
    : orgFilter
      ? invitees.filter((p) => !p.external && p.org === orgFilter)
      : invitees;

  if (state === WHOS_WHO_STATE.LOADING) {
    return (
      <Column spacing="300" spacingInset="300 none none none">
        <SkeletonCard />
        <SkeletonCard />
        <SkeletonCard />
        <SkeletonCard />
      </Column>
    );
  }

  const isError = state === WHOS_WHO_STATE.ERROR;

  return (
    <Column spacing="300" spacingInset="none 100">
      {isError && (
        <Alert type="warning" size="small">
          Some profile details are temporarily unavailable.
        </Alert>
      )}

      {hasInvitees && (
        <>
          <Row spacing="200" alignmentVertical="center" wrap="down">
            <Text type="h100">
              {orgFilter
                ? `${visibleInvitees.length} of ${invitees.length} participants`
                : `${invitees.length} participants`}
            </Text>
            <Text type="b100" color="secondary">Powered by Aza</Text>
          </Row>

          <WhosWhoOrgPills
            orgs={orgsList}
            orgColorMap={orgColorMap}
            activeOrg={orgFilter}
            onSelect={setOrgFilter}
          />

          {visibleInvitees.map((person) => (
            <InviteeCard
              key={person.id || person.alias || person.email}
              person={person}
              isError={isError}
              accentColor={accentFor(person, orgColorMap)}
            />
          ))}
        </>
      )}
    </Column>
  );
};

export default LegacyWhosWhoPanel;
